module.exports = __webpack_public_path__ + "img/products-modulos-y-cabinas.1e42a93a.jpeg";